import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import SignInForm from 'Forms/SignInForm';
import { SecondaryText } from 'Components/Texts';
import { ReCaptchaFinePrint } from 'Components/FinePrint';
import { GIFTING_QUERY_PARAM } from 'Utils/Constants';
import { isDefaultPlanFlow } from 'Utils/Analytics/Amplitude';
import { ForgotPasswordLink } from './ForgotPasswordLink';
import { SignInTVProviderButton } from 'Features/SignIn/ProviderButton/SignInTVProviderButton';
import './ProfileSignIn.css';

const ProfileSignIn = ({
  handleFormSubmit,
  routes,
  isGifting,
  isDeviceActivation = false,
  user = {},
  defaultConfig = {},
  bango = {},
  isSpecialPromo,
}) => (
  <Fragment>
    <SignInForm
      onFormSubmit={handleFormSubmit}
      isDeviceActivation={isDeviceActivation}
      routes={routes}
      defaultEmailValue={user.email}
    />
    <div className={isDeviceActivation ? 'forgotWithMargin' : 'forgotPasswordLinkContainer'}>
      <ForgotPasswordLink routes={routes} text="Forgot password?" />
    </div>
    {!isGifting && !isDeviceActivation && (
      <SecondaryText
        className="signUpNowText"
        alignText="centerText"
        text={[
          'New to Fox Nation? ',
          <Link
            key="signUpLinkTextKey"
            to={
              isSpecialPromo || bango.subscriptionId || isDefaultPlanFlow()
                ? routes.signupCreateAccount
                : routes.signupPlans
            }
            className="blueLink"
          >
            Sign up now
          </Link>,
        ]}
      />
    )}
    {!bango.subscriptionId && (
      <>
        {!isGifting && (
          <>
            <div className="orLineContainer">
              <span className="secondaryText">OR</span>
            </div>
            <SignInTVProviderButton text="Sign In" isDisabled={false} />
          </>
        )}
        <SecondaryText
          className="needHelpLink"
          alignText="centerText"
          text={[
            <a key="helpLink" href="http://foxnation.com/help" className="blueLink" target="_blank">
              Need help?
            </a>,
          ]}
        />
      </>
    )}
    {defaultConfig.signInCaptchaEnabled && <ReCaptchaFinePrint className="signInCaptchaDisclaimer" />}
    {isGifting && (
      <SecondaryText
        alignText="centerText"
        text={[
          "You don't have an account yet? ",
          <Link
            key="signUpLink"
            data-testid="gifting__signUpNowLink"
            to={{
              pathname: routes.signupCreateAccount,
              search: `${isGifting ? GIFTING_QUERY_PARAM : ''}`,
            }}
            className="blueLink"
          >
            Sign up now
          </Link>,
        ]}
      />
    )}
  </Fragment>
);

export default ProfileSignIn;
